import { Api_ENDPOINT } from "../constant";
import { PageType } from "../Models/Enum";
import { Page_SearchRequest, PageSummary_SearchRequest } from "../Models/Model";
import ApiService from "./apiService";

// AuthManager.tsx
class PageService {
  private static instance: PageService;
  public baseURL= Api_ENDPOINT;  
  private apiService : ApiService ;
  private constructor() {
    this.apiService = ApiService.getInstance();
  }

  public static getInstance(): PageService {
    if (!PageService.instance) {
      PageService.instance = new PageService();
    }
    return PageService.instance;
  }

  public WebPage_Get = async (req: Page_SearchRequest) => { 
     return await this.apiService.post(this.baseURL,"/Pages/WebPage_Get", req);
  };


  public PageSummary_Search = async (req: PageSummary_SearchRequest) => {
    return await this.apiService.post (this.baseURL,"/Pages/PageSummary_Search", req);
  };
 
}

export default PageService;







